import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcNavigation = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        {...props}
    >
        <g fill="currentColor">
            <path
                fillRule="evenodd"
                d="M0 1.738C0 .79.738.023 1.647.023h6.589c.91 0 1.647.768 1.647 1.715v6.857c0 .947-.738 1.714-1.647 1.714H1.647C.737 10.31 0 9.542 0 8.595V1.738Zm1.647-.245a.24.24 0 0 0-.235.245v6.857a.24.24 0 0 0 .235.245h6.589a.24.24 0 0 0 .235-.245V1.738a.24.24 0 0 0-.235-.245H1.647ZM0 15.453c0-.947.738-1.715 1.647-1.715h6.589c.91 0 1.647.768 1.647 1.715v6.857c0 .947-.738 1.714-1.647 1.714H1.647C.737 24.024 0 23.256 0 22.31v-6.857Zm1.647-.245a.24.24 0 0 0-.235.245v6.857a.24.24 0 0 0 .235.245h6.589a.24.24 0 0 0 .235-.245v-6.857a.24.24 0 0 0-.235-.245H1.647ZM14.117 1.738c0-.947.738-1.715 1.647-1.715h6.589c.91 0 1.647.768 1.647 1.715v6.857c0 .947-.738 1.714-1.647 1.714h-6.589c-.91 0-1.647-.767-1.647-1.714V1.738Zm1.647-.245a.24.24 0 0 0-.235.245v6.857a.24.24 0 0 0 .236.245h6.588a.24.24 0 0 0 .235-.245V1.738a.24.24 0 0 0-.235-.245h-6.589Z"
                clipRule="evenodd"
            />
            <path d="M14.823 15.452c0-.54.422-.98.942-.98h6.588c.52 0 .941.44.941.98v6.857c0 .541-.421.98-.941.98h-6.588c-.52 0-.942-.439-.942-.98v-6.857Z" />
        </g>
    </svg>
);
export default SvgIcNavigation;
